import { useState, useEffect } from "react";
import { Divider, Col, Row, Image, Button } from "antd";
import "antd/dist/reset.css";
import "../../containers/customLayout.css";
import { Link, useNavigate, useParams } from "react-router-dom";

import {
  login,
} from "../../security/AppSecurity";
import ProgrammeSubscription from "../programme/ProgrammeSubscription";
import { programmes } from "../../utils/apiConstants";
import { getClosingDate } from "./NysUtil";

export const NysLandingView = () => {

  const params = useParams();
  const navigate = useNavigate();

  const [showApply, setShowApply] = useState(false);
  const [title, setTitle] = useState("");

  const programme = programmes.find(p => p.key === 'nys-programme');

  const showButton = localStorage.getItem('nys-subscription');

  useEffect(() => {
    redirect();
  }, []);

  const redirect = () => {
    if (params.key) {
      let path = `/nys/candidate/details/${params.key}`;
      navigate(path);
    } else {
      isNysApplicationOpen();
    }
  };

  const isNysApplicationOpen = async () => {

    const nysApplication = await getClosingDate();
    const _showApply = nysApplication?.open || false;
    setShowApply(_showApply);
    setTitle(nysApplication?.message);
  }

  return (
    // <>
      <div>
        <Row>
          <Col xs={24}>
            <div className="slider">
              <div>
                <h1>
                  {" "}
                  Welcome to the DSTI National Youth Service (NYS) Application
                  Portal!
                </h1>
                {showApply && (

                  <Button
                    className="apply-btn"
                    onClick={() => navigate("/login")}
                  >
                    Apply here
                  </Button>
                )}

              <h3 style={{ color: "#ffffff" }}>{title}</h3>
              <h3>
                All enquiries: MacDonald Kapu <br />
                Tel: (012) 392 9351
                <br />
                Email:{" "}
                <a
                  className="link-style"
                  href="mailto:nysprecruitment@saasta.nrf.ac.za"
                >
                  nysprecruitment@saasta.nrf.ac.za
                </a>
              </h3>
              {/* <h3>
                View statistcs for past intakes
                <Link to="/report-nys" > here</Link>
              </h3> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row style={{ paddingBottom: 30 }}>
        <Col xs={24}>
          <Row>
            <Col xs={24}>
              <div className="nys-initiative">
                <h2> DSTI-National Youth Service Programme </h2>
              </div>
            </Col>
          </Row>
          <Row justify="center">
            <Col sm={22} lg={9}>
              <div className="nys-initiative-img">
                <Image
                  style={{ maxHeight: "400px" }}
                  xs={24}
                  md={6}
                  src={require("../../assets/NYS-initiative.jpg")}
                  alt="SEIMS: NYS initiative"
                  preview={false}
                />
              </div>
            </Col>
            <Col sm={22} lg={11}>
              {/* <div className="nys-initiative-img">
                    <Image height={400} xs={24} md={6} src={require("../assets/NYS-initiative.jpg")} />
                  </div> */}
              <div className="nys-initiative-text">
                <p>
                  The Department of Science and Innovation-National Youth
                  Service (DSTI-NYS) programme is a component of the government's
                  overall National Youth Service Programme (NYS). Managed by the
                  South African Agency for Science and Technology Advancement of
                  the National Research Foundation, the DSTI-NYS programme places
                  unemployed graduates who are under 35 years old in partner
                  institutions for 12 months while also providing them with
                  monthly stipends to cover their basic needs.{" "}
                </p>
                <p>
                  Although the emphasis is primarily on unemployed graduates in
                  the fields of science, technology, engineering, and
                  mathematics, there are occasionally a few spots open for
                  graduates in other fields as well, as defined by the relevant
                  recruitment process. The DSTI-NYS programme, which aims to
                  instil a culture of community service and volunteerism, offers
                  young people the chance to participate in skill-building
                  opportunities and a way out of long-term unemployment by
                  providing them with practical opportunities that increase
                  their likelihood of accessing the economy and instil in them
                  an understanding of their significant role in South Africa's
                  development.
                </p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row style={{ backgroundColor: "#5599C8", paddingBottom: 30 }}>
        <Col xs={24}>
          <Row>
            <Col xs={24}>
              <div className="nys-requirements">
                <h2> We are looking for someone who has...</h2>
              </div>
            </Col>
          </Row>
          <Row justify="center">
            <Col sm={22} lg={11}>
              <div className="nys-checklist-text">
                <ul>
                  <li>
                    A relevant tertiary qualification e.g. Science or
                    Technology, Journalism and Media Studies, Communications{" "}
                  </li>
                  <li>Computer literacy </li>
                  <li>Self-motivation and ability to work under pressure </li>
                  <li>Excellent communication and organisational skills </li>
                  <li>Writing and/or radio and television skills</li>
                  <li>Good analytical and interpersonal skills </li>
                </ul>
              </div>
            </Col>
            <Col sm={22} lg={11}>
              <div className="nys-checklist-img">
                <Image
                  style={{ maxHeight: "400px" }}
                  sm={24}
                  md={6}
                  src={require("../../assets/checklist.jpg")}
                  alt="SEIMS: NYS checklist"
                  preview={false}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row style={{ backgroundColor: "#fff", paddingBottom: 30 }}>
        <Col xs={24}>
          <Row>
            <Col xs={24}>
              <div className="nys-documents">
                <h2>Documents Required</h2>
              </div>
            </Col>
          </Row>
          <Row justify="center">
            <Col
              sm={22}
              md={10}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <div className="nys-documents-img">
                <Image
                  style={{ maxHeight: "400px", textAlign: "right" }}
                  src={require("../../assets/documents-required.jpg")}
                  alt="SEIMS: NYS application documents"
                  preview={false}
                />
              </div>
            </Col>
            <Col sm={22} md={10}>
              <div className="nys-documents-text">
                <ul>
                  <li>Curriculum Vitae (CV) </li>
                  <li>Certified ID Copy </li>
                  <li>Motivational Letter </li>
                  <li>Certified Copy of Highest Qualification</li>
                  <li>Certified Copy of Matric Certificate</li>
                </ul>
              </div>
            </Col>
          </Row>
          <Row justify={"center"}>
            <Col sm={22} md={10}></Col>
          </Row>
        </Col>
      </Row>
      <Divider />
      {/* <ProgrammeSubscription programme={programme} showButton={showButton} /> */}
    </div>
    // </>
  );
};
